var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dashboard-card',{attrs:{"loading":_vm.loading,"type":"line","options":_vm.chartOptions,"series":_vm.series,"title":"New to Triage Average Time (Hours)"}})
}
var staticRenderFns = []

export { render, staticRenderFns }